import React from "react";
import { Link } from "react-router-dom";
import "./TableRow.css";
import useEventOddsSocket from "../../hooks/useEventOddsSocket";

const TableRow = ({ i, row, isMobile, username }) => {
  const socketUsername =
    username !== undefined &&
      username !== null &&
      String(username).trim() !== ""
      ? String(username)
      : "guest";

  const liveMarket = useEventOddsSocket(row?.event_id, socketUsername);
  if (liveMarket) {
    console.log(
      "LIVE MARKET:",
      row?.event_id,
      liveMarket
    );
  }
  const getMatchDateTime = () => {
    if (!row?.open_date) return "";

    const date = new Date(row.open_date);

    if (Number.isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  // ==================== DYNAMIC ODDS LOGIC (REVISED & ROBUST) ====================
  // const placeholderOdd = {
  //   price: "0",
  //   size: "",
  // };

  // const liveMarketTypes =
  //   liveMarket?.market_types || liveMarket?.marketTypes || [];

  // const matchOddsMarket = liveMarketTypes.find((market) => {
  //   const marketName = String(market?.market_name || market?.marketName || "")
  //     .trim()
  //     .toLowerCase();

  //   return marketName === "match odds" || marketName === "match_odds";
  // });

  // const marketRunners =
  //   matchOddsMarket?.runners || matchOddsMarket?.marketRunners || [];

  // const backOdds = [];
  // const layOdds = [];

  // for (let index = 0; index < 3; index++) {
  //   const runner = marketRunners[index];

  //   if (!runner) {
  //     backOdds.push({
  //       ...placeholderOdd,
  //     });

  //     layOdds.push({
  //       ...placeholderOdd,
  //     });

  //     continue;
  //   }

  //   backOdds.push({
  //     price: runner.back_1_price ?? runner.backPrice ?? "0",

  //     size: runner.back_1_size ?? runner.backSize ?? "",
  //   });

  //   layOdds.push({
  //     price: runner.lay_1_price ?? runner.layPrice ?? "0",

  //     size: runner.lay_1_size ?? runner.laySize ?? "",
  //   });
  // }

  // const odds = [...backOdds, ...layOdds];
  // ==============================================================================

  // ==================== SIX MARKET-DEPTH ODDS ====================
  const liveMarketTypes =
    liveMarket?.market_types || liveMarket?.marketTypes || [];

  const isLive =
    row?.is_inplay === true ||
    row?.is_inplay === 1 ||
    row?.is_inplay === "1" ||
    String(row?.is_inplay).toLowerCase() === "true";

  const matchOddsMarket = liveMarketTypes.find((market) => {
    const marketName = String(market?.market_name || market?.marketName || "")
      .trim()
      .toLowerCase();

    return marketName === "match odds" || marketName === "match_odds";
  });

  const marketRunners =
    matchOddsMarket?.runners || matchOddsMarket?.marketRunners || [];

  // Single UpcomingEvents row mein
  // first runner ka complete depth.
  const formatOdd = (value) => {
    if (
      value === undefined ||
      value === null ||
      value === "" ||
      Number(value) === 0
    ) {
      return "-";
    }

    return value;
  };

  /*
 * Cricket/2-runner market:
 *
 * 1 = first runner
 * X = empty
 * 2 = second runner
 *
 * 3-runner market:
 *
 * 1 = first runner
 * X = second runner
 * 2 = third runner
 */
  const outcomeRunners =
    marketRunners.length === 2
      ? [
        marketRunners[0],
        null,
        marketRunners[1],
      ]
      : [
        marketRunners[0] || null,
        marketRunners[1] || null,
        marketRunners[2] || null,
      ];

  const outcomeLabels = ["1", "X", "2"];

  const outcomes = outcomeLabels.map((label, index) => {
    const runner = outcomeRunners[index];

    return {
      label,

      back: {
        price: runner
          ? formatOdd(
            runner?.back_1_price ??
            runner?.backPrice
          )
          : "-",

        size: runner
          ? runner?.back_1_size ??
          runner?.backSize ??
          ""
          : "",
      },

      lay: {
        price: runner
          ? formatOdd(
            runner?.lay_1_price ??
            runner?.layPrice
          )
          : "-",

        size: runner
          ? runner?.lay_1_size ??
          runner?.laySize ??
          ""
          : "",
      },
    };
  });
  // ==============================================================

  const teamNames = row?.event_name?.split(" v ") || ["Team A", "Team B"];
  // const linkTo = `/matchupdates/${row.event_id}/${row.is_inplay === "True" ? "Inplay" : "Going Inplay"}`;
  const linkTo = `/matchupdates/${row.event_id}/${isLive ? "Inplay" : "Going Inplay"
    }`;

  if (!isMobile) {
    return (
      <Link
        to={linkTo}
        className="desktop-event-link"
      >
        <article className="desktop-event-row">
          {/* Event name and date */}
          <div className="desktop-event-information">
            <span className="desktop-event-name">
              {row?.event_name || "Event"}
            </span>

            <span className="desktop-event-date">
              {" / "}
              {getMatchDateTime()}
            </span>
          </div>

          {/* Markets/icons */}
          <div className="desktop-event-icons">
            {isLive && (
              <span
                className="desktop-live-dot"
                title="Live"
                aria-label="Live"
              />
            )}

            <span
              className="desktop-tv-icon"
              title="Live streaming"
            >
              <i
                className="d-icon icon-tv"
                aria-hidden="true"
              />
            </span>

            <img
              src={`${process.env.PUBLIC_URL}/Images/ic_fancy.webp`}
              alt="Fancy"
              className="desktop-market-icon desktop-fancy-icon"
            />

            <img
              src={`${process.env.PUBLIC_URL}/Images/ic_bm.webp`}
              alt="Bookmaker"
              className="desktop-market-icon desktop-bm-icon"
            />

            {(row?.event_type === 1 ||
              row?.event_type === "1") && (
                <span
                  className="desktop-gamepad-icon"
                  title="Game"
                  aria-label="Game"
                >
                  <i
                    className="fas fa-gamepad"
                    aria-hidden="true"
                  />
                </span>
              )}
          </div>

          {/* 1, X and 2 back/lay odds */}
          {outcomes.map((outcome) => (
            <React.Fragment key={outcome.label}>
              <div className="desktop-odd desktop-back-odd">
                <strong>{outcome.back.price}</strong>
              </div>

              <div className="desktop-odd desktop-lay-odd">
                <strong>{outcome.lay.price}</strong>
              </div>
            </React.Fragment>
          ))}
        </article>
      </Link>
    );
  }

  return (
    <Link to={linkTo} className="reference-event-link">
      <article className="reference-event-row">
        {/* Row 1: Event name and available markets */}
        <div className="reference-event-heading">
          <span className="reference-event-name">
            {row?.event_name || "Event"}
          </span>

          <div className="reference-event-icons">
            {isLive && (
              <span
                className="reference-live-dot"
                title="Live"
                aria-label="Live"
              />
            )}

            <span
              className="reference-tv-icon"
              title="Live streaming"
            >
              <i
                className="d-icon icon-tv"
                aria-hidden="true"
              />
            </span>

            <img
              src={`${process.env.PUBLIC_URL}/Images/ic_fancy.webp`}
              alt="Fancy"
              className="reference-market-icon reference-fancy-icon"
            />

            <img
              src={`${process.env.PUBLIC_URL}/Images/ic_bm.webp`}
              alt="Bookmaker"
              className="reference-market-icon reference-bm-icon"
            />

            {(row?.event_type === 1 ||
              row?.event_type === "1") && (
                <span
                  className="reference-gamepad-icon"
                  aria-label="Game"
                >
                  ♣
                </span>
              )}
          </div>
        </div>

        {/* Row 2: Date and outcome headings */}
        <div className="reference-event-meta">
          <span className="reference-event-date">
            {getMatchDateTime()}
          </span>

          <div className="reference-outcome-headings">
            {outcomes.map((outcome) => (
              <span key={outcome.label}>
                {outcome.label}
              </span>
            ))}
          </div>
        </div>

        {/* Row 3: Back/Lay odds */}
        <div className="reference-event-odds">
          {outcomes.map((outcome) => (
            <React.Fragment key={outcome.label}>
              <div className="reference-odd reference-back-odd">
                <strong>{outcome.back.price}</strong>

                {/* {outcome.back.size !== "" &&
                  outcome.back.price !== "-" && (
                    <small>{outcome.back.size}</small>
                  )} */}
              </div>

              <div className="reference-odd reference-lay-odd">
                <strong>{outcome.lay.price}</strong>

                {/* {outcome.lay.size !== "" &&
                  outcome.lay.price !== "-" && (
                    <small>{outcome.lay.size}</small>
                  )} */}
              </div>
            </React.Fragment>
          ))}
        </div>
      </article>
    </Link>
  );
};

export default TableRow;
